module.exports = __webpack_public_path__ + "img/Not_found_dog.2ac025d0.svg";